export default __webpack_public_path__ + "static/media/2-cloudxier-shooper-highlight03.205d14f3.jpg";